import { $,_,Foundation,moment } from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'
import InboomaBaseCollectionView from '../InboomaBaseCollectionView'
import { Notification } from '../../utils'

import PricetariffsItemTpl from '../../templates/pricetariffs/PricetariffsItemTpl.html'

const PricetariffsItemView = InboomaBaseView.extend({

  template : PricetariffsItemTpl,
  className : 'inb-c-item inb-c-item--pricetariff row',

  ui : {
    dropdown : '.inb-dropdown',
    priceRemove : '.inb-pricetariff__remove'
  },

  modelEvents : {
    'sync' : 'render'
  },

  events : {
    'click @ui.priceRemove' : '_removePricetariff'
  },

  templateContext () {
    return {
        _,
        moment
    }
  },

  onRender () {

    const dd = this.getUI('dropdown');

    setTimeout(function() {
        new Foundation.Dropdown(dd);
    }, 0);

  },

  _removePricetariff (target) {

    const that = this;

    if (confirm(this.t('really_remove'))) {
        this.model.destroy({ success (model, repsonse) {

            that.$el.fadeOut('fast');

            new Notification({
                message : that.t('removed_${a}',{a:that.t('pricetariff')},'capital'),
                duration : 5000,
                closeable : true,
                icon : 'fi fi-trash'
            });

        }});
    };
    
    return false;
  },

});

export default InboomaBaseCollectionView.extend({

  childView: PricetariffsItemView,
  template : _.noop,

  initialize () {
      this.render();
  },

  onRender() {
      $('.inb-c-loader').remove();
  }

});
